import globalStyle from '@/styles/Global.scss';
import React, {useEffect, useState} from "react";
import Layout from "@/layout/Layout";
import {useHistory, useParams} from "react-router";
import ImageCard from "@/components/ImageCard";
import AttributeEditor from "@/components/AttributeEditor";
import {Card} from "@/entity/Card";
import {getCard, update, deleteCard} from "@/api/card";
import MButton from "@/components/atom/MButton";
import {Form} from "react-bootstrap";
import {addTemporaryFile} from "@/api/file";
import {TemporaryFile} from "@/entity/TemporaryFile";

const WatashiCardEdit = () => {
  const history = useHistory()
  const {id} = useParams()
  const [card, setCard] = useState(new Card({}))

  useEffect(() => {
    (async () => {
      const card = await getCard({id})
      setCard(card)
    })()
  }, [id])

  const toBack = () => {
    history.push(`/watashi/${id}`)
  }
  const save = async () => {
    await update({id, card})
    history.push(`/watashi/${id}`)
  }

  const handleOnChange = (attributes) => {
    setCard(new Card({...card, attributes}))
  }

  const readFrontSideFile = (e) => {
    handleFile(e, 'tmpFileId')
  }

  const readBackSideFile = (e) => {
    handleFile(e, 'backSideTmpFileId')
  }

  const handleFile = (e, filePropName) => {
    e.preventDefault()
    if (!e.target.files.length) {
      return
    }
    let file = e.target.files[0]
    let fr = new FileReader()
    fr.onload = async (event) => {
      const dataURI = event.target.result
      const contents = dataURI.split(',')[1] || dataURI
      const temporaryFile = await addTemporaryFile({ temporaryFile: new TemporaryFile({ mime: file.type, contents }) })
      const prop = { ...card }
      prop[filePropName] = temporaryFile.id
      setCard(new Card({...prop}))
    }
    fr.readAsDataURL(file)
  }

  const handleDeleteCard = async () => {
    if (card.canExchange) {
      window.alert('QR発行済みの名刺は削除できません。')
      return
    }
    const confirm = window.confirm("この名刺を削除します。よろしいですか？")
    if (!confirm) {
      return
    }
    await deleteCard({id})
    history.push(`/card`)
  }

  return (
    <>
      <Layout category={'WA'}>
        <div className={globalStyle.container}>
          <div className={globalStyle.bodyContainer}>
            <div className={globalStyle.body}>
              <div className={globalStyle.centerPanel}>
                <ImageCard id={id}></ImageCard>
                <div>
                  名刺名称: <input type={'text'} value={card.name}
                                   onChange={(e) => setCard(new Card({...card, name: e.target.value}))}/>
                </div>
                <div style={{ marginTop: '10px' }}>
                  <label>
                    <input
                      type="checkbox"
                      checked={!!card.isPublic}
                      onChange={(e) => setCard(new Card({ ...card, isPublic: e.target.checked }))}
                      style={{ marginRight: '8px' }}
                    />
                    公開する（この名刺を誰でも閲覧できるようにします）
                  </label>
                </div>
                <Form style={{ marginLeft: '5vw', marginRight: '5vw' }}>
                  <Form.Group controlId="formFile" className="mb-3">
                    <Form.Label>名刺ファイルを選択して、保存をクリックしてください。</Form.Label>
                    <Form.Label style={{ width: "90vw", textAlign: "left"}}>表面ファイルの選択</Form.Label>
                    <Form.Control onInput={readFrontSideFile} type="file" accept="image/*"/>
                    <Form.Label style={{ width: "90vw", textAlign: "left"}}>裏面ファイルの選択</Form.Label>
                    <Form.Control onInput={readBackSideFile} type="file" accept="image/*"/>
                  </Form.Group>
                </Form>
                <AttributeEditor id={id} edit={true} attributes={card.attributes}
                                 onChange={(attributes) => handleOnChange(attributes)}></AttributeEditor>
              </div>
            </div>
          </div>
          <div className={globalStyle.footerContainer}>
            <div className={globalStyle.footer}>
              <div className={globalStyle.centerPanel}>
                <MButton image={'hozon.png'} value={'保存'} onClick={ save }></MButton>
                <MButton image={'back.png'} value={'戻る'} onClick={ toBack }></MButton>
                <MButton image={'sakujo.png'} value={'削除'} onClick={ handleDeleteCard }></MButton>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  )
}

export default WatashiCardEdit
